<template>
  <div class="bottom">
    <div class="bottom_contact">
      <div class="contact" @click="openMail()">
        <img src="@/assets/image/foot_icon2.png" class="contact_img" alt />
        higgsweb3@gmail.com
      </div>
      <div class="contact" @click="openTwitter()">
        <img src="@/assets/image/foot_icon1.png" class="contact_img" alt />
        https://twitter.com/HiggsWeb3
      </div>
      <div class="contact" @click="contactsDialogVisible = true">
        <img src="@/assets/image/foot_icon3.png" class="contact_img" alt />
        Business Contacts
      </div>
    </div>

    <div class="bottom_logo">
      <img
        class="bottom_middle_logo"
        referrerpolicy="no-referrer"
        src="./../assets/image/bottom_middle_logo.png"
      />
    </div>

    <!--    联系人  -->
    <el-dialog
      :visible.sync="contactsDialogVisible"
      width="40%"
      :close-on-click-modal="false"
      class="higgs_module_contacts"
    >
      <img
        class="higgs_module_contacts_img"
        referrerpolicy="no-referrer"
        src="./../assets/image/higgs_module_contacts.png"
      />
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 联系人弹框
      contactsDialogVisible: false,
    }
  },
  methods: {
    // 邮箱
    openMail() {
      window.open('mailto:higgsweb3@gmail.com', '_blank')
    },
    // twitter
    openTwitter() {
      window.open('https://twitter.com/HiggsWeb3', '_blank')
    },
  },
}
</script>

<style lang="less">
.bottom {
  width: 100%;
  height: 300px;
  background: #173b6e;

  .bottom_contact {
    display: flex;
    justify-content: center;
    align-items: center;

    padding: 64px 0 0 0;

    .contact {
      width: auto;
      height: 60px;
      background: rgba(255, 255, 255, 0.2);
      border-radius: 40px 40px 40px 40px;

      font-weight: normal;
      font-size: 18px;
      color: #ffffff;
      line-height: 60px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      white-space: nowrap;

      display: flex;
      justify-content: center;
      align-items: center;

      padding: 0 40px 0 40px;
      margin: 0 2% 0 2%;
      cursor: pointer;

      .contact_img {
        width: 28px;
        height: 29px;
        object-fit: contain;

        margin: 0 33px 0 0;
      }
    }
  }

  .bottom_logo {
    display: flex;
    justify-content: center;
    align-items: center;

    margin: 59px 0 0 0;
    .bottom_middle_logo {
      width: 173px;
      height: 37px;
      object-fit: contain;
    }
  }
}

.higgs_module_contacts {
  .el-dialog {
    .el-dialog__body {
      text-align: center;

      .higgs_module_contacts_img {
        width: 400px;
        height: 400px;
      }
    }
  }
}

@media screen and (max-width: 1080px) {
  .bottom {
    width: 100%;
    height: 300px;
    background: #173b6e;

    .bottom_contact {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;

      padding: 46px 30px 0 30px;

      .contact {
        width: 100%;
        height: 46px;
        background: rgba(255, 255, 255, 0.2);
        border-radius: 40px 40px 40px 40px;

        font-weight: normal;
        font-size: 14px;
        color: #ffffff;
        line-height: 46px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        white-space: nowrap;

        display: flex;
        justify-content: flex-start;
        align-items: center;

        padding: 0 15px 0 15px;
        margin: 0 0 12px 0;
        cursor: pointer;

        .contact_img {
          width: 28px;
          height: 29px;
          object-fit: contain;

          margin: 0 23px 0 0;
        }
      }
    }

    .bottom_logo {
      display: flex;
      justify-content: center;
      align-items: center;

      margin: 20px 0 0 0;
      .bottom_middle_logo {
        width: 173px;
        height: 37px;
        object-fit: contain;
      }
    }
  }

  .higgs_module_contacts {
    .el-dialog {
      width: 90% !important;
      .el-dialog__body {
        text-align: center;

        .higgs_module_contacts_img {
          width: 300px !important;
          height: 300px !important;
        }
      }
    }
  }
}
</style>